import _ from '@lodash';
import { useEffect } from 'react';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableFilterListDto from 'modules/base/dto/table/TableFilterListDto';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import VizsgaFeladatTableService from '../service/VizsgaFeladatTableService';

const myConfig = data => {
	return {
		key: 'vizsgaFeladatTable',
		text: 'Vizsgafeladat',
		textKey: 'vizsgaFeladatTable',
		service: VizsgaFeladatTableService,
		backLink: () => '/vizsga-feladatsor',
		editFormState: item => `/vizsga-feladat/edit/${item ? item.id : 'new'}/${data.vizsgafeladatsor}`,
		toolbarAction: ['refresh'],
		rowAction: ['modify'],
		defaultFilter: () => {
			return new TableFilterListDto().setup({
				list: [
					{
						propertyName: 'vizsgafeladatsor',
						type: 'EQ',
						value: data.vizsgafeladatsor,
						permanent: false
					}
				],
				activeCount: 1
			});
		},
		columns: [
			{
				key: 'genKerdesSorszam',
				text: 'Kérdés sorszám',
				textKey: 'genKerdesSorszam',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'genSorszam',
				text: 'Sorszám',
				textKey: 'genSorszam',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'torolt',
				text: 'Törölt',
				textKey: 'torolt',
				type: 'boolean',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'kerdesLeirasPlaintext',
				text: 'Kérdés leírás',
				textKey: 'kerdesLeirasPlaintext',
				type: 'text',
				sortable: false,
				disablePadding: false
			}
		]
	};
};

function VizsgaFeladatTable() {
	const { vizsgafeladatsor } = useParams();
	const sessionName = useSelector(rootState => rootState.vizsgaFeladatTable.tableBrowserSession.sessionName);
	useEffect(() => {
		return () => {
			VizsgaFeladatTableService.setFilter(sessionName, new TableFilterListDto());
		};
	}, []);
	const config = myConfig({ vizsgafeladatsor: Number.parseInt(vizsgafeladatsor, 10) });
	return <TableBrowser config={config} />;
}

export default withReducer('vizsgaFeladatTable', reducer('vizsgaFeladatTable'))(VizsgaFeladatTable);
